export default __webpack_public_path__ + "static/woman-895b40718288ae706a8b4d1c92815e32.png";